<template>
    <n-modal :show="isCSModalshow" preset="card" title="Dialog" size="small" :style="ModalStyle()">
        <template #header>
            <div>Urgent Message</div>
        </template>
        <div v-if="isResponsePageShow == false">
            <n-form size="small" label-placement="left" :model="formRequests" ref="formRef">
                <n-form-item path="content">
                    <n-input  type="textarea" v-model:value="formRequests.content" maxlength="500" show-count placeholder="Please leave your message" :autosize="{ minRows: 10, maxRows: 10 }"/>
                </n-form-item>
                    <n-space justify="end">
                        <n-button type="info" @click="submitHandler" style="background-color: #1D1F9C" attr-type="button" :disabled="isContentEmpty == true ||isSubmitBtnLoading ==true" :loading="isSubmitBtnLoading === true">Submit</n-button>
                    </n-space>
            </n-form>
        </div>
        <div v-else>
            <div v-if="responseStatus == 'success'">
                <SuccessResult :id="fdRequestId" @modalClose="closeModal"/>
            </div>

            <div v-if="responseStatus == 'error'">
                <ErrorResult @modalClose="closeModal"/>
            </div>
        </div>
    </n-modal>
</template>

<script>
import {NModal, NButton, NForm, NFormItem, NInput, NSpace} from "naive-ui"
import {ref, watch} from "vue"
import axios from "axios"
import SuccessResult from "../../../components/result/success/Success-Result"
import ErrorResult from "../../../components/result/error/Error-Result"
import {useReCaptcha} from "vue-recaptcha-v3"

export default{
    name: "CustomerServiceModal",
    props:["isCSModalshow","salesorderDetails"],
    components:{
        NModal,
        NButton,
        NForm,
        NFormItem,
        NInput,
        NSpace,
        SuccessResult,
        ErrorResult
    },
    setup(props, {emit}){
        // console.log(props,"props")
        // console.log(process.env.NODE_ENV)
        const { executeRecaptcha, recaptchaLoaded} = useReCaptcha();
        const isContentEmpty = ref(true)
        const formRef = ref(null)
        const isSubmitBtnLoading = ref(false)
        const isResponsePageShow = ref(false)
        const responseStatus = ref(null)
        const fdRequestId = ref(null)
        const formRequests = ref({
            content:"",
        })
        const closeModal = () =>{
            emit("close")
        }

        const ModalStyle = () =>{
            if(document.body.clientWidth < 764) return "width:80%"
            if(document.body.clientWidth >= 764) return "width:500px"
        }

        watch(() =>  formRequests.value.content,(newValue)=>{
            if( newValue.length != 0) isContentEmpty.value = false
            else isContentEmpty.value = true
        })

        const submitHandler = async(e) =>{
            e.preventDefault()
            // console.log(e,formRef.value)
            
            const description = `
                <div>Order Ref: <b>${props.salesorderDetails.refnumber}</b></div>
                <br />
                <h4>Message: </h4>
                <div>${formRef.value.model.content}</div>
            `
            const tickets = {
                name: props.salesorderDetails.billpersonfullname,
                phone: props.salesorderDetails.billpersonmobile,
                email: props.salesorderDetails.customeremail,
                // name: "Yude",
                // phone: "0210314269",
                // email: "yhua924@gmail.com",
                cc_emails: ["sian@tradedepot.com"],
                priority: 4,
                status: 2,
                source: 100,
                group_id: 51000182232,
                subject: `Escalate to CS Manager - ${props.salesorderDetails.refnumber}`,
                description: description,
            }

            isSubmitBtnLoading.value = true

            await recaptchaLoaded()
            const token = await executeRecaptcha("homepage");

            console.log({ token });
            const params = new URLSearchParams();
            params.append('recaptchakey', token);
            
            // axios.all([axios.post(`recaptcha/signup`, params),  axios.post(`fd/tickets`, tickets, {timeout: 1000 * 10})])
            axios.all([axios.post(`https://help-api.tradedepot.co.nz/api/v1/recaptcha/signup`, params),  axios.post(`https://help-api.tradedepot.co.nz/api/v1/fd/tickets`, tickets, {timeout: 1000 * 10})])
                .then(axios.spread((recaptcha,ticket) => {
                    // console.log(ticket)
                    if(recaptcha.data.score >= 0.5){
                        if(ticket.status == 200 && ticket.data.success === true){
                            fdRequestId.value = ticket.data.data.id
                            isResponsePageShow.value = true
                            responseStatus.value = "success"
                            isSubmitBtnLoading.value = false
                            
                        }else{
                            isResponsePageShow.value = true
                            responseStatus.value = "error"
                        }
                    }else{
                        responseStatus.value = "error"
                        isResponsePageShow.value = true
                    }
                }))
                .catch(err => console.err(err))
                
            // axios.post(`fd/tickets`, tickets, {timeout: 1000 * 10})
            //     .then(res => {
            //          if(res.data.success === true){
            //             //  console.log("success")
            //                 fdRequestId.value = res.data.data.id
            //                 isResponsePageShow.value = true
            //                 responseStatus.value = "success"
            //                 isSubmitBtnLoading.value = false
                            
            //             }else{
            //                 // console.log("fail")
            //                 isResponsePageShow.value = true
            //                 responseStatus.value = "error"
            //             }
            //     })
            //     // .then(() => isSubmitBtnLoading.value = false)
            //     .catch(err => {
            //         console.log(err)
            //         isResponsePageShow.value = true
            //         responseStatus.value = "error"
            //     })

        }
        return{
            formRef,
            isContentEmpty,
            closeModal,
            ModalStyle,
            // ...toRefs(formRequests),
            formRequests,
            submitHandler,
            isResponsePageShow,
            responseStatus,
            isSubmitBtnLoading,
            fdRequestId
        }
    }
}
</script>